import React, { FC } from 'react'
import { IOrderInProgressProduct } from '../../../../../../models/order/aggregates/progress/IInProgressOrder'
import "./ProductItemDetail.css"
import { ICurrency } from 'models/local/ILocalConfig'
interface IProductDetailsProps {
    productDetail: IOrderInProgressProduct
}
export const ProductItemDetail: FC<IProductDetailsProps> = ({ productDetail }) => {
    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

    return (
        <div id="productDetails">
            <div className="container">
                <div className="quantidade">
                    {productDetail.quantity}
                </div>
                <div className="name">
                    {productDetail.name}
                </div>
            </div>
            <div className="total">
                {currency?.symbol ?? "R$"} {productDetail.total.toFixed(2)}
            </div>
        </div>
    )
}
